import { render, staticRenderFns } from "./ViewContacts.vue?vue&type=template&id=6c259ce7&scoped=true"
import script from "./ViewContacts.vue?vue&type=script&lang=js"
export * from "./ViewContacts.vue?vue&type=script&lang=js"
import style0 from "./ViewContacts.vue?vue&type=style&index=0&id=6c259ce7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c259ce7",
  null
  
)

export default component.exports